import React, { useCallback } from 'react';
import { useIsSmallScreen } from '../../../../../../../Hooks/useFullscreenView';
import EDIconButton from '../../../../../../../BaseComponents/Buttons/IconButton/EDIconButton';
import EDButton from '../../../../../../../BaseComponents/Buttons/Button/EDButton';
import EDIcon from '../../../../../../../BaseComponents/Icon/EDIcon';
import { AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All } from '../../Queries/_QueryTypes/AttestantQuery';

interface IProps {
  setEditStandin: React.Dispatch<
    React.SetStateAction<
      undefined | AttestantQuery_node_TEDLRAttestant__Associations_Reserver_All
    >
  >;

  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const AddReservButton: React.FC<React.PropsWithChildren<IProps>> = props => {
  const isSmallScreen = useIsSmallScreen();

  const onClick = useCallback(() => {
    props.setEditStandin(undefined);
    props.setDialogOpen(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isSmallScreen ? (
        <EDIconButton
          color="primary"
          icon="add"
          margin="none"
          onClick={onClick}
          padding="dense"
          tooltip="Lägg till ny Frånvaroperiod"
          testId="reserv-add"
        />
      ) : (
        <EDButton
          color="primary"
          flat
          icon={<EDIcon iconType="add" color="primary" />}
          onClick={onClick}
          testId="reserv-add"
        >
          Lägg till ny frånvaroperiod
        </EDButton>
      )}
    </>
  );
};

export default AddReservButton;
